import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
var trendStyles = {
  default: {
    color: 'uiDD',
    backgroundColor: 'uiD'
  },
  none: {
    color: 'terciaryLL',
    backgroundColor: 'terciary'
  },
  empty: {
    color: 'fontLL',
    backgroundColor: 'positiveM'
  },
  bull: {
    color: 'uiDD',
    backgroundColor: 'positive'
  },
  bear: {
    color: 'uiDD',
    backgroundColor: 'negative'
  },
  range: {
    color: 'uiDD',
    backgroundColor: 'primary'
  }
};
export var Label = styled.span.withConfig({
  displayName: "partials__Label",
  componentId: "sc-jbvs3z-0"
})(["padding:1.5px 4px;color:#fff;border:1px solid ", ";background-color:", ";font-weight:600;"], function (_ref) {
  var theme = _ref.theme,
    trend = _ref.trend;
  return !trend ? 'currentColor' : theme.colors[trendStyles[trend].backgroundColor];
}, function (_ref2) {
  var theme = _ref2.theme,
    trend = _ref2.trend;
  return !trend ? 'currentColor' : theme.colors[trendStyles[trend].backgroundColor];
});
export var Value = styled.span.withConfig({
  displayName: "partials__Value",
  componentId: "sc-jbvs3z-1"
})(["padding:1.5px 2px;font-weight:500;padding-left:6px;color:", ";border:1px solid ", ";"], function (_ref3) {
  var theme = _ref3.theme,
    trend = _ref3.trend,
    _ref3$withTextColor = _ref3.withTextColor,
    withTextColor = _ref3$withTextColor === void 0 ? true : _ref3$withTextColor;
  return !trend || !withTextColor ? theme.colors.uiDD : theme.colors[trendStyles[trend].color];
}, function (_ref4) {
  var theme = _ref4.theme,
    trend = _ref4.trend;
  return !trend ? 'currentColor' : theme.colors[trendStyles[trend].backgroundColor];
});
export var Spacer = styled.span.withConfig({
  displayName: "partials__Spacer",
  componentId: "sc-jbvs3z-2"
})(["display:inline-block;width:6px;"]);
export var Tag = styled.span.withConfig({
  displayName: "partials__Tag",
  componentId: "sc-jbvs3z-3"
})(["", " display:inline-flex;border-radius:", ";text-wrap:nowrap;white-space:nowrap;", ""], getFont(-1), function (_ref5) {
  var theme = _ref5.theme,
    border = _ref5.border;
  return border === 'square' ? '0px' : theme.borderRadius;
}, function (_ref6) {
  var fullWidth = _ref6.fullWidth;
  return fullWidth && "\n    width: 100%;\n\n    ".concat(Value, " {\n      width: 100%;\n      text-align: center;\n      margin-left: 2px;\n    }\n  ");
});